<template>
  <PagesProgramSlugComponent
    :pageData="data"
    :parentPageData="parentData"
  />

  <NuxtPage />
</template>

<script lang="ts" setup>
// 1
defineI18nRoute({
  paths: {
    en: '/programme/[slug]',
    nl: '/programma/[slug]'
  }
})

// 2
const queryPath = queryProgramEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.length || error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: 'Page not found',
    stack: ''
  })
}

pageSetHead(data)

// 3
const { data: parentData, error: parentError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryProgramsPageThumbnail() } }
  )
})
</script>
